import { Routes, Route, NavLink } from "react-router-dom";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminFeedback from "@/pages/admin/AdminFeedback";
import AdminSurveys from "@/pages/admin/AdminSurveys";
import AdminQuizzes from "@/pages/admin/AdminQuizzes";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPseudos from "@/pages/admin/AdminPseudos";
import AdminResidences from "@/pages/admin/AdminResidences";
import AdminCitizens from "@/pages/admin/AdminCitizens";
import AdminPerks from "@/pages/admin/AdminPerks";

export default function AdminDashboard() {
  return (
    <Routes>
      <Route index element={<AdminOverview />} />
      <Route path="remontees" element={<AdminFeedback />} />
      <Route path="sondages" element={<AdminSurveys />} />
      <Route path="jeux" element={<AdminQuizzes />} />
      <Route path="utilisateurs" element={<AdminUsers />} />
      <Route path="pseudos" element={<AdminPseudos />} />
      <Route path="residences" element={<AdminResidences />} />
      <Route path="citoyens" element={<AdminCitizens />} />
      <Route path="avantages" element={<AdminPerks />} />
    </Routes>
  );
}
